import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTW: CultureInfo = {
  name: 'en-TW',
  displayName: 'English (Taiwan)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TW',
  parent: CultureInfoEn
};
